import type { HTMLAttributes, ReactNode } from "react";
import styles from "./HistoryItem.module.css";
import { cx } from "../cx";
import { IconBrick } from "../icons/Icon";

export type HistoryItemTone = "positive" | "neutral" | "critical";

export type HistoryItemProps = HTMLAttributes<HTMLDivElement> & {
  /** 서버 label 그대로 */
  label: ReactNode;
  /** 부호 포함 수량. 양수는 +, 음수는 − 로 표시한다. */
  amount: number;
  /** 색·강조: grant·refund positive(fg-brand) / spend·expire neutral / revoke critical */
  tone?: HistoryItemTone;
  /** 기기 로컬로 포맷한 시각 문자열(앱이 만든다). 날짜 그룹 헤더를 쓰는 화면은 생략 */
  at?: ReactNode;
  /** 부제(주문번호·만료 일시) */
  sub?: ReactNode;
  /** 수량 앞 아이콘 (기본 브릭 16) */
  icon?: ReactNode;
  /** 우측 값을 직접 준다(결제 내역의 결제 금액, Figma 122:6542). 주면 amount·icon 대신 이 값만 표시 */
  value?: ReactNode;
};

/** 결제·사용 내역 행 (Figma 100:4180). 라벨 t5 Medium + 부제 t3, 우측 브릭 16 + 수량 t5 Bold. py12 → 부제 없으면 46, 있으면 66. */
export function HistoryItem({ label, amount, tone = "neutral", at, sub, icon, value, className, ...rest }: HistoryItemProps) {
  const sign = amount > 0 ? "+" : amount < 0 ? "−" : "";
  const abs = Math.abs(amount).toLocaleString("ko-KR");
  return (
    <div className={cx(styles.root, styles[tone], className)} {...rest}>
      <span className={styles.texts}>
        <span className={styles.label}>{label}</span>
        {(at || sub) && (
          <span className={styles.meta}>
            {at && <span>{at}</span>}
            {sub && <span className={cx(at ? styles.sub : undefined)}>{sub}</span>}
          </span>
        )}
      </span>
      <span className={styles.amount}>
        {value ?? (
          <>
            <span className={styles.icon}>{icon ?? <IconBrick size={16} />}</span>
            {sign}
            {abs}
          </>
        )}
      </span>
    </div>
  );
}
